"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("../AbstractComponent"));
var DownloadController_1 = __importDefault(require("./DownloadController"));
var constantsDownload_1 = require("../../data/constantsDownload");
var constantsClasses_1 = require("../../data/constantsClasses");
/**
 * Open download modal and add/remove visual download items to cart
 *
 * @author Kevin Buchholz <kevin.buchholz@wendweb.de>
 */
var DownloadModal = /** @class */ (function (_super) {
    __extends(DownloadModal, _super);
    function DownloadModal(selector) {
        var _this = _super.call(this, selector) || this;
        _this.strMaxLength = 30;
        if (!_this.getElement()) {
            return _this;
        }
        DownloadModal.modal = _this.getElement();
        _this.itemBlueprint = DownloadModal.modal.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM_BLUEPRINT, "]"));
        _this.downloadAllBtn = DownloadModal.modal.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_DOWNLOAD_ALL, "]"));
        _this.modalContent = DownloadModal.modal.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_MODAL_CONTENT, "]"));
        _this.modalOpenBtn = document.querySelector('[data-header]').querySelectorAll("[".concat(constantsDownload_1.DATA_DOWNLOAD_MODAL_OPEN, "]"));
        _this.modalCloseBtn = DownloadModal.modal.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_MODAL_CLOSE, "]"));
        _this.initEventListeners();
        _this.getCurrentCartItems();
        return _this;
    }
    Object.defineProperty(DownloadModal.prototype, "CartItems", {
        get: function () {
            return this.cartItems;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Init modal component listeners.
     */
    DownloadModal.prototype.initEventListeners = function () {
        var _this = this;
        // Open modal
        this.modalOpenBtn.forEach(function (element) {
            element.addEventListener('click', function (e) {
                DownloadModal.openModal();
                e.preventDefault();
            });
        });
        // Close modal
        this.modalCloseBtn.addEventListener('click', function () {
            DownloadModal.closeModal();
        });
        // Close modal (outer click)
        this.getElement().addEventListener('click', function (event) {
            _this.closeOnOuterClick(event);
        });
        // Download all cart items
        this.downloadAllBtn.addEventListener('click', function () {
            DownloadController_1.default.downloadAllItems();
            DownloadModal.closeModal();
        });
    };
    /**
     * Build and add blueprint item to DOM of cart when calling 'add' function.
     */
    DownloadModal.prototype.buildVisualItem = function (response) {
        // Create element
        var item = document.createElement('template');
        item.innerHTML = this.itemBlueprint.outerHTML.trim();
        // Convert to DOM element
        var el = item.content.firstChild;
        if (el.classList.contains('d-none')) {
            el.classList.remove('d-none');
        }
        // Create element components
        var img = el.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM_IMAGE, "] img"));
        img.src = "".concat(window.location.origin, "/").concat(response.object.thumbnail);
        el.dataset.downloadName = "".concat(response.object.fileName, ".").concat(response.object.fileType);
        el.setAttribute('data-download-cart-item', '');
        el.removeAttribute('data-download-cart-item-blueprint');
        el.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM_SIZE, "]")).innerHTML += response.object.fileSize;
        el.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM_TYPE, "]")).innerHTML += response.object.fileType;
        // Truncate file name if it is too long
        var str = response.object.customTitle;
        var fileName = str.length > this.strMaxLength ? str.substring(0, this.strMaxLength - 3) + '...' : str.substring(0, this.strMaxLength);
        el.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM_HEADLINE, "]")).innerHTML = fileName;
        this.modalContent.appendChild(el);
        // Update active items list and update visual cart
        this.getCurrentCartItems();
    };
    /**
     * Remove cart element from cart DOM tree.
     */
    DownloadModal.prototype.removeVisualItem = function (fileName) {
        // Update active items list
        this.getCurrentCartItems();
        this.cartItems.forEach(function (cartItem) {
            if (fileName == cartItem.dataset.downloadName) {
                cartItem.remove();
            }
        });
    };
    /**
     * Remove download item from cart.
     * @private
     */
    DownloadModal.prototype.removeItem = function (filePath) {
        DownloadController_1.default.removeItem(filePath, true);
    };
    /**
     * Remove all visual items from cart
     */
    DownloadModal.prototype.clearCart = function () {
        // Update active items list
        this.getCurrentCartItems();
        this.cartItems.forEach(function (cartItem) {
            cartItem.remove();
        });
        this.modalContent.classList.add(constantsClasses_1.CLASS_EMPTY);
    };
    /**
     * Get all existing cart items in DOM tree and their delete buttons.
     * @private
     */
    DownloadModal.prototype.getCurrentCartItems = function () {
        var _this = this;
        this.cartItems = this.modalContent.querySelectorAll("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM, "]"));
        this.cartItems.forEach(function (element) {
            var removeBtn = element.querySelector("[".concat(constantsDownload_1.DATA_DOWNLOAD_CART_ITEM_REMOVE, "]"));
            removeBtn.addEventListener('click', function () {
                _this.removeItem(element.dataset.downloadName);
            });
        });
    };
    /**
     * Check if cart is empty in DOM to add 'empty' class.
     * @param count
     */
    DownloadModal.prototype.checkIfCartEmpty = function (count) {
        if (count > 0) {
            this.modalContent.classList.remove(constantsClasses_1.CLASS_EMPTY);
        }
        else {
            this.modalContent.classList.add(constantsClasses_1.CLASS_EMPTY);
        }
    };
    /**
     * Close modal on outer click.
     * @param event
     * @private
     */
    DownloadModal.prototype.closeOnOuterClick = function (event) {
        var elements = event.composedPath();
        // -2 because we want to skip document and window
        for (var i = 0; i < elements.length - 2; i++) {
            var el = elements[i];
            // Don't trigger if modal content is targeted
            if (el.classList.contains('download-modal__wrapper') || el.classList.contains('page-header__action')) {
                return;
            }
        }
        DownloadModal.closeModal();
    };
    /**
     * Open modal.
     */
    DownloadModal.openModal = function () {
        DownloadModal.modal.classList.add(constantsClasses_1.CLASS_OPEN);
    };
    /**
     * Close modal.
     */
    DownloadModal.closeModal = function () {
        if (DownloadModal.modal.classList.contains(constantsClasses_1.CLASS_OPEN)) {
            DownloadModal.modal.classList.remove(constantsClasses_1.CLASS_OPEN);
        }
    };
    return DownloadModal;
}(AbstractComponent_1.default));
exports.default = DownloadModal;
